export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://adminproveedoresosh.convel.co/',
  apiGatewayBackOffice: 'https://adminproveedoresosh.convel.co/',
  apiUrl: 'https://adminproveedoresosh.convel.co/',
  urlPath: 'https://adminproveedoresosh.convel.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LfpCBopAAAAAO7AZoQMY8qfI3KnU5JfXKzADvkS',

  googleAnalyticsCode: 'UA-140785247-1',
};